import script from "./CandidatesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CandidatesModal.vue?vue&type=script&setup=true&lang=ts"

import "./CandidatesModal.vue?vue&type=style&index=0&id=1e337d32&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e337d32"]])

export default __exports__